import { downloadCsv } from '@qtek/shared/utils';

function normalizeCsvCellValue(value: string | null): string {
  return (value ?? '').replace(/\s+/g, ' ').trim();
}

export function exportTableElementAsCsv(table: HTMLTableElement): void {
  const rows = Array.from(table.querySelectorAll('tr'));
  const csvRows = rows
    .map(row =>
      Array.from(row.querySelectorAll('th, td'))
        .filter(cell => !cell.classList.contains('qt-col--rownum'))
        .map(cell => normalizeCsvCellValue(cell.textContent))
    )
    .filter(row => row.length > 0);

  if (!csvRows.length) {
    return;
  }

  downloadCsv(csvRows, `allo-table-${Date.now()}.csv`, {
    lineBreak: '\r\n',
    prependBom: true,
  });
}
